import moment from "moment";

export default {
    formatTime: (value) => {
        if (!value) return '';
        value = '2011-10-10T' + value
        return moment.parseZone(value).format('h:mma');
    },

    capitalize: (value) => {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
    },


    formatPhoneNumber: (value) => {

        if (!value) return '';

        var cleaned = ('' + value).replace(/\D/g, '');
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            var intlCode = (match[1] ? '+1 ' : '');

            return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
        }
        return value;
    },

    guarantees: (value) => {
        if (value === 'GuaranteeRequired') {
            return 'Guarantee Required'
        } else {
            return value
        }
    },

    formatTime1: (value) => {
        if (!value) return '';
        return moment.parseZone(value).format('h:mma');
    },

    formatDate: (value) => {
        if (!value) return '';
        return moment.parseZone(value).format('ddd, MMM D');
    },

    formatDate2: (value) => {  
        if (!value) return '';
        return moment.parseZone(value).format('MMM D');
     },

    formatDateTime: (value) => {
        if (!value) return '';
        return moment.parseZone(value).format('MMM D, Y [at] h:mma');
    },

    displayScore: (value) => {
        if (!value) return '';
        return Math.round(value / 10);
    },

    operatedBy: (value) => {
        if (!value) return '';
        return 'Operated by ' + value;
    },

    formatCarriers: (value) => {
        if (!value) return '';
        if (value.length === 1) return value[0];
        return 'Multiple airlines';
    },

    formatRating: (value) => {
        if (!value) return '';

        let roundedRating = Math.round(value);
        let stars;

        switch (roundedRating) {
            case 0:
                stars = '★☆☆☆☆';
                break;
            case 1:
                stars = '★☆☆☆☆';
                break;
            case 2:
                stars = '★★☆☆☆';
                break;
            case 3:
                stars = '★★★☆☆';
                break;
            case 4:
                stars = '★★★★☆';
                break;
            case 5:
                stars = '★★★★★';
                break;
            default:
                stars = 'n/a';
        }

        return 'On-time rating ' + stars;
    },

    formatDuration: (value) => {
        if (!value) return '';
        let hours = (value / 60);
        let rhours = Math.floor(hours);
        let minutes = (hours - rhours) * 60;
        let rminutes = Math.round(minutes);
        return rhours + 'h ' + rminutes + 'm';
        // return moment.utc().startOf('day').add(value, 'minutes').format('h[h] m[m]');
    },

    formatPriceFromCents: (value) => {
        if (!value) return '';
        return '$' + Math.round(value / 100);
    },

    formatPriceFromDollars: (value, decimals) => {
        if (!value) return ''
        if (!decimals) {
            let decimals = 0
        }
        return '$' + Number(value).toFixed(decimals);
    },

    formatCurrency: (value, decimals = 0) => {
        if (!value) value = 0;

        if (value < 0) {
            return '-$' + Math.abs(value).toFixed(decimals)
        } 
        return '$' + Number(value).toFixed(decimals);
    },

    formatLayovers: (value) => {
        if (!value) return 'nonstop';
        if (value === 1) return value + ' stop';
        return value + ' stops';
    },

    journeyLabel: (index, total) => {
        if (index === false) return '';
        let number = index + 1;

        if (total === 1) return '';

        if (total === 2) {
            if (number === 1) return 'Departure';

            if (number === 2) return 'Return';
        }
        return number + ' of ' + total;
    },

    formatOTPRating: (value) => {
        if (!value) return '';

        let roundedRating = Math.round(value);
        let stars;
        let text;
        let rating;

        switch (roundedRating) {
            case 0:
                stars = '★☆☆☆☆';
                text = 'Poor';
                rating = 'has-text-danger';
                break;
            case 1:
                stars = '★☆☆☆☆';
                text = 'Poor';
                rating = 'has-text-danger';
                break;
            case 2:
                stars = '★★☆☆☆';
                text = 'Poor';
                rating = 'has-text-danger';
                break;
            case 3:
                stars = '★★★☆☆';
                text = 'Average';
                rating = 'has-text-info';
                break;
            case 4:
                stars = '★★★★☆';
                text = 'Good';
                rating = 'has-text-success';
                break;
            case 5:
                stars = '★★★★★';
                text = 'Excellent';
                rating = 'has-text-success';
                break;
            default:
                stars = 'N/A';
                text = 'Not Found';
                rating = 'has-text-info';
        }

        return `<span class="text-center ${rating}">${stars}</span>`;
    },

    formatPercentage: (dec) => {
        if (dec <= 1) {
            return Math.round(dec * 100) + "%";
        }
        return 'Please enter number less than or equal to 1'
    },

    roundDecimal: (value) => {
        if (!value) return;

        return value.toFixed(2);
    },

    translateString: (value) => {
        if (value == 'Y') return 'Yes'
        if (value == 'N') return 'No'

        return value;
    },
}